
import { useCallback, useEffect } from "react";
import apiClient from "../api/admin-api-client";
import useAsync from "../hooks/use-async";

export default function useAdminAllCategories() {
    const { data, isIdle, isPending, isError, isSuccess, run } = useAsync();

    useEffect(() => {
        reload();
    }, []);

    const reload = useCallback(() => run(apiClient("categories")).catch(() => { }));

    return {
        categories: data?.data || [],
        isPending: isIdle || isPending,
        isError,
        isSuccess,
        reload,
    };
}